var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scene layout"},[_c('iframe',{attrs:{"src":_vm.base+'//www.4dmodel.com/SuperTwoCustom/jinggangshan/SuperTwoJingGangShan/index.html?m='+_vm.link,"frameborder":"0"}}),_vm._v(" "),_c('bar')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7130d4ac","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/scene/index.vue
// module id = null
// module chunks = 